import { MODULE } from "./requiredDate.actionTypes";

export const getRequiredStartDate = (state) => state.getIn([MODULE, "requiredStartDate"]);

export const getRequiredEndDate = (state) => state.getIn([MODULE, "requiredEndDate"]);
